export const INVOICEREPORTLIST_SEARCH = 'INVOICEREPORTLIST_SEARCH';
export const INVOICEREPORTLIST_PAGE = 'INVOICEREPORTLIST_PAGE';
export const INVOICEREPORTLIST_MONTH = 'INVOICEREPORTLIST_MONTH';
export const INVOICEREPORTLIST_YEAR = 'INVOICEREPORTLIST_YEAR';
export const INVOICEREPORTLIST_MONTHEND = 'INVOICEREPORTLIST_MONTHEND';
export const INVOICEREPORTLIST_YEAREND = 'INVOICEREPORTLIST_YEAREND';
export const INVOICEREPORTLIST_CLIENT = 'INVOICEREPORTLIST_CLIENT';